import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import Vue from "vue";
import VueSpinners from "vue-spinners";

import InputSwitch from "primevue/inputswitch";
import InputText from "primevue/inputtext";
import Dropdown from "primevue/dropdown";
import MultiSelect from "primevue/multiselect";
import DataTable from "primevue/datatable";
import Column from "primevue/column";

//Date picker
import InputNumber from "primevue/inputnumber";
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";

//OTP INPUT
import VOtpInput from "vue3-otp-input";

//Chartjs

import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
  ArcElement,
} from "chart.js";
ChartJS.register(
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
  ArcElement
);

//Primevue
import Chips from "primevue/chips";
import Primevue from "primevue/config";
import ProgressBar from "primevue/progressbar";
import "primevue/resources/themes/lara-light-teal/theme.css";

//ANTD
import Antd from "ant-design-vue";
import "ant-design-vue/dist/reset.css";

//Toast
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";
const options = {
  // You can set your default options here
  timeout: 2000,
};
import { useToast } from "vue-toastification";

//Date picker css
import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";

//Custom Font
import "@fontsource-variable/inter";
import "./assets/styles/main.css";
import mitt from "mitt";

// Implementation
const emitter = mitt();
const app = createApp(App);
app.config.globalProperties.$toast = useToast();
app.config.globalProperties.$emitter = emitter;

app
  .use(Primevue)
  .use(VueSpinners)
  .use(store)
  .use(router)
  .use(Toast, options)
  .use(Antd)
  .component("v-otp-input", VOtpInput)
  .component("VueDatePicker", VueCtkDateTimePicker)
  .component("InputText", InputText)
  .component("Chips", Chips)
  .component("InputNumber", InputNumber)
  .component("Dropdown", Dropdown)
  .component("ProgressBar", ProgressBar)
  .component("MultiSelect", MultiSelect)
  .component("InputSwitch", InputSwitch)
  .component("DataTable", DataTable)
  .component("Column", Column)
  .mount("#app");

export const { toast } = useToast();
